import {format as formatDateFns, isValid, parse} from 'date-fns';

export const DEFAULT_DISPLAY_FORMAT = 'dd-MM-yyyy';

const SUPPORTED_FORMATS = ['dd-MM-yyyy', 'dd.MM.yyyy', 'dd/MM/yyyy'];

export const formatDate =
  (format: string = DEFAULT_DISPLAY_FORMAT) =>
  (date: Date) =>
    formatDateFns(date, format);

export const parseDate = (displayFormat?: string) => (dateStr: string) => {
  if (!dateStr) return undefined;

  const formats = displayFormat
    ? Array.from(new Set([...SUPPORTED_FORMATS, displayFormat]))
    : SUPPORTED_FORMATS;

  for (const format of formats) {
    const parsed = parse(dateStr, format, new Date());
    if (isValid(parsed) && formatDateFns(parsed, format) === dateStr) {
      return parsed;
    }
  }
  return undefined;
};

export type DateInput = Date | string | number;

export function toDate(input: DateInput | null | undefined): Date | undefined {
  if (input === undefined || input === null || input === '') return undefined;
  if (input instanceof Date) return Number.isNaN(input.getTime()) ? undefined : input;
  const next = new Date(input);
  return Number.isNaN(next.getTime()) ? undefined : next;
}

export function resetTime(date: DateInput) {
  const next = toDate(date) ?? new Date();
  next.setHours(0, 0, 0, 0);
  return next;
}
